module.exports = __webpack_public_path__ + "img/rocket.91b21e17.svg";